/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { get, map } from "lodash";

import {
  Pagination,
  Stack,
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import Layout from "../../../components/layout/Layout"
import Table from "../../../components/form/Table";
import Toolbar from "./Toolbar";
import Notification from "../../../components/form/Notification";
import { PageSize, countPage } from "../../../config/const"

import { getReportRouteCost } from "../../../store/reports/thunk/routeCost/getAll";

const ReportRouteCost = () => {
  const [__] = useTranslation("routeCost");
  const dispatch = useDispatch();

  const [filter, setFilter] = useState({});
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })

  const routeCost = useSelector(state => state.reports.routeCost);

  const getData = ({ page }) => {
    dispatch(getReportRouteCost({ page, PageSize, ClientId: 0, ...filter }))
  }

  const reload = () => {
    getData({ page: 1, filter })
  }

  useEffect(() => {
    if (filter.from && filter.till) {
      getData({ page: 1, filter })
    } else {
      getData({page: 1, filter: ""})
    }
  }, [dispatch, JSON.stringify(filter)])

  const headTable = [
    {
      key: "routeName",
      label: __(`table.cols.routeName`),
      align: "left",
    },
    {
      key: "numberPlate",
      label: __(`table.cols.numberPlate`),
      align: "left"
    },
    {
      key: "driverName",
      label: __(`table.cols.driverName`),
      align: "left",
    },
    {
      key: "date",
      label: __(`table.cols.routeCreationDate`),
      align: "center"
    },
    {
      key: "routeStatus",
      label: __(`table.cols.routeStatus`),
      align: "center"
    },
    {
      key: "nameCost",
      label: __(`table.cols.nameCost`),
      align: "center"
    },
    {
      key: "total",
      label: __(`table.cols.totalCost`),
      align: "center"
    },
  ]

  const dataTable = map(get(routeCost, "data.innerData", []), (row, i) => ({
    ...row,
    date: get(row, "routeCreationDate", null) && moment(get(row, "routeCreationDate")).format("L"),
    total: `$${get(row, "totalCost")}`,
  }))

  const onChangePagination = (e, page) => getData({ page, filter })

  return (
    <Layout
      propsToolbar={{
        title: __(`head.name`),
        code: null,
        btnLabel: null
      }}
    >
      <Toolbar setFilter={setFilter} __={__} getData={getData} reload={reload} isLoading={get(routeCost, "isLoading", false)} />
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        loading={get(routeCost, "isLoading", false)}
      />
      {get(routeCost, "isSuccess", true) &&
        <Stack sx={{ mt: 2 }} alignItems="flex-end">
          <Pagination
            count={countPage(get(routeCost, "totalRecords", 1))}
            page={get(routeCost, "pageNumber", 1)}
            onChange={onChangePagination}
            color="secondary"
            sx={{ "& li > button": { borderRadius: 1 } }}
          />
        </Stack>
      }
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
    </Layout >
  )
}

export default ReportRouteCost;


